import React from "react";
import bannerImg from "../../Assets/Cow-About-banner.png";
import "./AboutStaticBanner.css";

const StaticBanner = () => {
  return (
    <section className="about-vangal-section-wrapper">
      <div className="about-vangal-section-bg"></div>

      <div className="about-vangal-section-content">
        
        {/* Left Text */}
<div className="about-vangal-section-text anim anim-top">
  <h1>About Vangal Dairies</h1>
  <p>
    Established in 1993, Vangal Dairies has grown from a humble milk
    distribution unit into a trusted dairy manufacturer known for purity,
    authenticity, and traditional taste.
  </p>
</div>

        {/* Right Image */}
        <div className="about-vangal-section-image anim anim-bottom">
          <img src={bannerImg} alt="cow" />
        </div>

      </div>
    </section>
  );
};

export default StaticBanner;
